import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import DropdownHeader from './DropdownHeader';
import helpers from '../../utils/helpers';
import StoreIcon from '../../components/StoreIcon';

class PublishersList extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
  };
  shouldComponentUpdate() {
    return false;
  }
  render() {
    const {
      data,
    } = this.props;
    const renderList = data && data.map(item => (
      <li
        className="text-truncate pos-rel"
        key={`${item.ref_no}-${item.store}`}
      >
        <a href={item.url} className={isEmpty(item.list) ? 'no-arrow' : ''}>
          <div className="d-flex align-items-items applications-list justify-content-center pl-xs store-container text-xxxs">
            {item.store !== 'both' && <StoreIcon store={item.store} />}
            {item.store === 'both' && <div className="d-flex align-items-center"><div className="hicon-publisher text-16" /></div> }
          </div>
          <span className="ml-xs text-truncate">{helpers.decodeEntities(item.name || '')}</span>
        </a>
      </li>
    ));
    return (
      <Fragment>
        <div className="d-flex align-items-center pl-xs header" >
          <DropdownHeader headerName="Publishers" />
        </div>
        <ul className="items subsidiaries-list">
          { renderList }
          <div className="pb-xxs" />
        </ul>
      </Fragment>
    );
  }
}


export default PublishersList;
